import RegistrationIcon from "@/components/auth/registration/RegistrationIcon.tsx";
import AuthPageHeading from "@edusogno/layouts/auth-page-heading";
import { cn } from "@edusogno/lib/utils";

interface HeaderProps {
  title: string;
  subtitle?: string;
  logo: string;
  className?: string;
}

const RegistrationHeader = ({
  title,
  subtitle,
  logo,
  className,
}: HeaderProps) => {
  return (
    <div
      className={cn(
        "w-full flex flex-col   flex-[2_0_40%] lg:py-0 h-full items-center justify-center",
        className,
      )}
    >
      <div
        className={
          "flex flex-row items-center justify-center w-full h-[60px] xl:h-[70px]"
        }
      >
        <RegistrationIcon name={logo} />
      </div>
      <AuthPageHeading
        title={title}
        subtitle={subtitle}
        className={" [&_p]:text-secondary !px-0"}
      />
    </div>
  );
};

export default RegistrationHeader;
